import { Deposit } from './../models/deposit';
import { Component, OnInit, ViewEncapsulation, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { ListItem } from '../../../shared/list-confirmation/model/list-item';
import { FormGroup } from '@angular/forms';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { DepositEventType } from '../deposit-per-ticket.event.type';
import { TweenMax, Quint } from 'gsap';
import * as moment from 'moment';
import { FormatPricePipe } from '../../../shared/format-price.pipe';
import { EventTypes } from '../../../shared/EventTypes';
import { AutenticationService } from '../../../autentication/autentication.service';
import { Auth } from '../../../autentication/Auth';
import { ThemeService } from '../../../shared/theme-service/theme.service';
import { DepositPerTicketService } from './../deposit-per-ticket.service';

@Component({
	selector: 'app-deposit-confirmation',
	templateUrl: './deposit-confirmation.component.html',
	styleUrls: ['./deposit-confirmation.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class DepositConfirmationComponent implements OnInit, OnDestroy {

	@Input() submited = false;
	@Input() depositData: Deposit;
	@Output() setForm: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

	public form: FormGroup;
	private view = '[data-component="deposit-confirmation"]';
	private confirmList: Array<ListItem> = [];

	active = false;
	disabled = false;
	isSecuritieCip: boolean;
	isSecuritieAgreement: boolean;
	isAttendant: boolean = false;

	constructor(
		private depositPerTicketService: DepositPerTicketService,
		private autenticationService: AutenticationService,
		private themeService: ThemeService
	) { }

	ngOnInit() {
		this.isAttendant = this.themeService.isAttendant();
		AppEventDispatcher.listen(DepositEventType.STEPS.DEPOSIT_CONFIRM, data => {
			if (data.show) {
				this.active = true;
				this.show();
			} else {
				this.hide();
			}
		});

	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(DepositEventType.STEPS.DEPOSIT_CONFIRM);
	}

	onSetSignatureForm(form: FormGroup) {
		this.form = form;
		this.setForm.emit(this.form);
	}

	getStepHeight(): number {
		return $(this.view).outerHeight() + $('.buttons').outerHeight() + 60;
	}

	show() {

		this.buildConfirmList();

		TweenMax.delayedCall(.5, () => {
			const containerHeight = this.getStepHeight();

			TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut });
			TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut });
		});

	}

	buildConfirmList() {
		this.confirmList = [];
		const FP = new FormatPricePipe();
		this.confirmList.push(new ListItem('Valor:', FP.transform(this.depositData.value)));

		this.depositData.resumeList = this.confirmList;
	}

	hide() {
		this.preload(true);
		this.submited = false;
		this.disabled = true;

		let time = 1;
		const timeLoader = setInterval(() => {
			time++;
		}, 1000);

		this.readySend(timeLoader, time);

	}

	readySend(timeLoader, time) {

		this.preload(true);

		this.depositPerTicketService.getTicket(this.depositData.value).subscribe(data => {

			this.depositData.success = data.Sucesso;
			this.depositData.message = "Boleto gerado com sucesso!"

			this.depositData.generatedIn = moment(data.Retorno.DtGerado).format('DD/MM/YYYY HH:mm');
			this.depositData.payeeName = data.Retorno.NomeTitular;
			this.depositData.value = data.Retorno.Valor;
			this.depositData.maturity = moment(data.Retorno.DtVcto).format('DD/MM/YYYY HH:mm');
			this.depositData.digitableLine = data.Retorno.LinhaDigitavel;
			this.depositData.numberBankSlip = data.Retorno.NroTitulo;

			this.buildResumeList();

			if (time > 3) {
				this.preload(false);
				this.hideAfterSend();
			} else {
				TweenMax.delayedCall(3 - time, () => {
					this.preload(false, 3 - time);
					this.hideAfterSend();
				});
			}
			clearInterval(timeLoader);

		}, error => {

			AppEventDispatcher.dispatch(DepositEventType.ERROR, { step: DepositEventType.STEPS.DEPOSIT_DATA });

			if (time > 3) {
				this.preload(false);
				this.setForm.emit(this.form);
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			} else {
				TweenMax.delayedCall(3 - time, () => {
					this.preload(false, 3 - time);
					this.setForm.emit(this.form);
					AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
				});
			}
			clearInterval(timeLoader);


		});
	}

	buildResumeList() {

		const resumeList = [];

		resumeList.push(new ListItem('Boleto gerado em:', this.depositData.generatedIn));
		resumeList.push(new ListItem('Nome do favorecido:', this.depositData.payeeName, 'cls_mask'));
		const FP = new FormatPricePipe();
		resumeList.push(new ListItem('Valor:', FP.transform(this.depositData.value, false), 'cls_mask'));
		resumeList.push(new ListItem('Vencimento:', this.depositData.maturity));
		resumeList.push(new ListItem('Linha Digitável:', this.depositData.digitableLine, 'cls_mask'));
		resumeList.push(new ListItem('Valor disponível em sua conta:', 'Até 02 dias após o pagamento'));

		this.depositData.resumeList = resumeList;
	}

	hideAfterSend() {

		AppEventDispatcher.dispatch(DepositEventType.STEPS.DEPOSIT_RESULT, { show: true });

		TweenMax.to(this.view, .8, {
			left: '-100%', ease: Quint.easeOut, onComplete: () => {
				this.active = false;
			}
		});

	}

	checkAfterSend(timeLoader, time) {

		if (time > 3) {
			this.preload(false);
			this.hide();
		} else {
			TweenMax.delayedCall(3 - time, () => {
				this.preload(false);
				this.hide();
			});
		}
		clearInterval(timeLoader);
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{ element: '[data-component="deposit-per-ticket"] .content', show: active, delay: delay });
	}

	clearPreload(time, timeLoader) {
		if (time > 3) {
			this.preload(false);
		} else {
			TweenMax.delayedCall(3 - time, () => {
				this.preload(false, 3 - time);
			});
		}
		clearInterval(timeLoader);
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/deposit-per-ticket/deposit-confirmation/deposit-confirmation.component.ts